import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function getAuthHeaders () {
  return { 'Authorization': store.getters.getTokenId }
}

function getVehicleKwhUsageDaily ({ date, transportationProfileIds }) {
  return apiRequests.get('/v1/vehicle-kwh-usage/daily/', {
    params: { date, transportationProfileIds },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function saveVehicleKwhUsageBatch ({ date, entries }) {
  return apiRequests.post('/v1/vehicle-kwh-usage/batch/', {
    date,
    entries
  }, {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

export {
  getVehicleKwhUsageDaily,
  saveVehicleKwhUsageBatch
}
